import {
  AmountDimension,
  AmountLimitsDimension,
  CalendarDateDimension,
  ExclusionDimension,
  IntegerDimension,
  NumbersEnumDimension,
  StringsEnumDimension,
  StringsWithDataEnumDimension,
} from '@orus.eu/dimensions'
import {
  nlAovqlBenefitDurationEntries,
  nlAovqlIncapacityThresholds,
  nlAovqlProductVersions,
  nlAovqlProfessionalClasses,
  nlAovqlWaitingTimesInMonths,
} from '@orus.eu/product'

export const nlAovqlProductVersionDimension = new StringsEnumDimension({
  name: 'nlAovqlProductVersion',
  displayKeys: { name: 'dimension_name_nl_aovql_product_version' },
  values: nlAovqlProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlAovqlExclusionsDimension = new ExclusionDimension({
  name: 'nlAovqlExclusions',
  displayKeys: { name: 'dimension_name_nl_aovql_exclusions' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlAovqlProfessionalClassDimension = new StringsEnumDimension({
  name: 'nlAovqlProfessionalClass',
  displayKeys: { name: 'dimension_name_nl_aovql_professional_class' },
  values: nlAovqlProfessionalClasses,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlAovqlContractDurationInYearsDimension = new IntegerDimension({
  name: 'nlAovqlContractDurationInYears',
  displayKeys: { name: 'dimension_name_nl_aovql_contract_duration_in_years' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlAovqlMaxBirthDateDimension = new CalendarDateDimension({
  name: 'nlAovqlMaxBirthDate',
  displayKeys: { name: 'dimension_name_nl_aovql_max_birth_date' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlAovqlIncapacityThresholdDimension = new StringsEnumDimension({
  name: 'nlAovqlIncapacityThreshold',
  displayKeys: { name: 'dimension_name_nl_aovql_incapacity_threshold' },
  values: nlAovqlIncapacityThresholds,
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlAovqlMonthlyInsuredAmountDimension = new AmountDimension({
  name: 'nlAovqlMonthlyInsuredAmount',
  displayKeys: { name: 'dimension_name_nl_aovql_monthly_insured_amount' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlAovqlMonthlyInsuredAmountLimitsDimension = new AmountLimitsDimension({
  name: 'nlAovqlMonthlyInsuredAmountLimits',
  displayKeys: { name: 'dimension_name_nl_aovql_monthly_insured_amount_limits' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlAovqlWaitingTimeInMonthsDimension = new NumbersEnumDimension({
  name: 'nlAovqlWaitingTimeInMonths',
  displayKeys: { name: 'dimension_name_nl_aovql_waiting_time_in_months' },
  values: nlAovqlWaitingTimesInMonths,
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
  valuesAreAmount: false,
} as const)

export const nlAovqlBenefitDurationDimension = new StringsWithDataEnumDimension({
  name: 'nlAovqlBenefitDuration',
  displayKeys: { name: 'dimension_name_nl_aovql_benefit_duration' },
  entries: nlAovqlBenefitDurationEntries,
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
